import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/ui/components/ui/dialog";
import { Button } from "@/ui/components/ui/button";
import { useStore } from "@/state/legacy_module_api";

export function GlobalDialog() {
  const dialogState = useStore((state) => state.dialogState);
  const closeDialog = useStore((state) => state.closeDialog);

  if (!dialogState) return null;

  const handleConfirm = () => {
    if (dialogState.onConfirm) {
      dialogState.onConfirm();
    }
    closeDialog();
  };

  const handleCancel = () => {
    if (dialogState.onCancel) {
      dialogState.onCancel();
    }
    closeDialog();
  };

  return (
    <Dialog open={!!dialogState} onOpenChange={(open) => !open && handleCancel()}>
      <DialogContent data-name="global-dialog">
        <DialogHeader>
          <DialogTitle>{dialogState.title || "Alert"}</DialogTitle>
          {dialogState.message && (
            <DialogDescription>{dialogState.message}</DialogDescription>
          )}
        </DialogHeader>
        <DialogFooter>
          {dialogState.type === "confirm" && (
            <Button data-name="dialog-cancel-button" variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
          )}
          <Button data-name="dialog-confirm-button" onClick={handleConfirm}>
            {dialogState.type === "confirm" ? "Confirm" : "OK"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
